// extracted by mini-css-extract-plugin
export const footerLogo = "footer-module--footerLogo--1Rzhc";
export const footerHeading = "footer-module--footerHeading--1v63N";
export const rightFooterRow = "footer-module--rightFooterRow--V6CR4";
export const footerTop = "footer-module--footerTop--17JdN";
export const footerBottom = "footer-module--footerBottom--1sqtY";
export const scrollToTopButton = "footer-module--scrollToTopButton--3lD8s";
export const footerSocialLink = "footer-module--footerSocialLink--fzD1E";